var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHours(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 41.5,
    fill: "#292E36"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.117 26.8067C21.5545 30.792 19.5619 35.9245 19.5015 41.2582C19.3606 53.4554 29.3237 63.4588 41.5007 63.499C53.6778 63.5191 63.5 53.6567 63.5 41.4997C63.5 29.5239 53.9193 19.7621 42.0039 19.5005C41.9435 19.5005 41.863 19.5005 41.8026 19.5407C41.7423 19.5609 41.6819 19.6011 41.6416 19.6414C41.6014 19.6816 41.5611 19.742 41.5209 19.8024C41.5007 19.8628 41.4806 19.9232 41.4806 20.0037V29.5843",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9244 44.0762L29.8671 31.1342C29.7262 30.9531 29.6859 30.7317 29.706 30.5103C29.7262 30.2889 29.8067 30.0876 29.9677 29.9266C30.1287 29.7656 30.33 29.6851 30.5514 29.6649C30.7527 29.6448 30.9741 29.7052 31.1552 29.826L44.0971 38.8833C44.8821 39.4469 45.4255 40.3123 45.5866 41.2785C45.7476 42.2446 45.5262 43.2308 44.9626 44.0359C44.399 44.841 43.5537 45.3845 42.5876 45.5656C41.6215 45.7467 40.6352 45.5253 39.8301 44.9819C39.488 44.7404 39.1659 44.4385 38.9244 44.0762Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHours);
export default __webpack_public_path__ + "static/media/hours.33f958f362bf702b953cab80dd4acd67.svg";
export { ForwardRef as ReactComponent };